var _defs, _g, _g2, _polygon, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 448.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #6d6d6d;\r\n      }\r\n\r\n      .st2 {\r\n        fill: none;\r\n        stroke: #6d6d6d;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 9.2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84,392.5c0-1.2-.4-2.1-1.3-2.8-.9-.7-2.4-1.3-4.6-2.1-2.2-.7-4-1.4-5.3-2.1-3.5-1.9-5.3-4.5-5.3-7.7s.5-3.2,1.4-4.5c1-1.3,2.3-2.4,4.1-3.1,1.8-.7,3.8-1.1,6-1.1s4.2.4,6,1.2c1.7.8,3.1,1.9,4.1,3.4,1,1.5,1.4,3.1,1.4,5h-6.4c0-1.4-.5-2.5-1.4-3.3-.9-.8-2.2-1.2-3.8-1.2s-2.8.3-3.7,1-1.3,1.5-1.3,2.6.5,1.9,1.5,2.6c1,.7,2.5,1.3,4.5,1.9,3.7,1.1,6.3,2.5,8,4.1s2.5,3.7,2.5,6.1-1,4.8-3.1,6.4c-2,1.5-4.8,2.3-8.3,2.3s-4.6-.4-6.6-1.3c-2-.9-3.5-2.1-4.5-3.6-1-1.5-1.6-3.3-1.6-5.3h6.5c0,3.4,2.1,5.2,6.2,5.2s2.7-.3,3.6-.9c.9-.6,1.3-1.5,1.3-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105,401.1c-3.4,0-6.2-1-8.3-3.1-2.1-2.1-3.2-4.9-3.2-8.3v-.6c0-2.3.5-4.4,1.4-6.2.9-1.8,2.2-3.2,3.8-4.2s3.5-1.5,5.6-1.5c3.2,0,5.7,1,7.5,3,1.8,2,2.7,4.8,2.7,8.5v2.5h-14.8c.2,1.5.8,2.7,1.8,3.6,1,.9,2.3,1.4,3.8,1.4,2.4,0,4.3-.9,5.6-2.6l3,3.4c-.9,1.3-2.2,2.3-3.8,3.1-1.6.7-3.3,1.1-5.3,1.1ZM104.3,382.1c-1.2,0-2.2.4-3,1.2-.8.8-1.3,2-1.5,3.6h8.6v-.5c0-1.4-.4-2.4-1.1-3.2-.7-.8-1.7-1.1-3-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.6,400.7h-6.2v-32.9h6.2v32.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.4,401.1c-3.4,0-6.2-1-8.3-3.1-2.1-2.1-3.2-4.9-3.2-8.3v-.6c0-2.3.5-4.4,1.4-6.2.9-1.8,2.2-3.2,3.8-4.2s3.5-1.5,5.6-1.5c3.2,0,5.7,1,7.5,3,1.8,2,2.7,4.8,2.7,8.5v2.5h-14.8c.2,1.5.8,2.7,1.8,3.6,1,.9,2.3,1.4,3.8,1.4,2.4,0,4.3-.9,5.6-2.6l3,3.4c-.9,1.3-2.2,2.3-3.8,3.1-1.6.7-3.3,1.1-5.3,1.1ZM139.7,382.1c-1.2,0-2.2.4-3,1.2-.8.8-1.3,2-1.5,3.6h8.6v-.5c0-1.4-.4-2.4-1.1-3.2-.7-.8-1.7-1.1-3-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.1,396.1c1.1,0,2.1-.3,2.8-.9s1.1-1.5,1.1-2.5h5.8c0,1.6-.4,3-1.3,4.3-.8,1.3-2,2.3-3.5,3-1.5.7-3.1,1.1-4.9,1.1-3.3,0-5.9-1.1-7.8-3.2s-2.9-5-2.9-8.7v-.4c0-3.6.9-6.4,2.9-8.6s4.5-3.2,7.8-3.2,5.2.8,7,2.5,2.6,3.8,2.7,6.6h-5.8c0-1.2-.4-2.2-1.1-2.9s-1.7-1.1-2.8-1.1-2.5.5-3.3,1.6c-.7,1.1-1.1,2.8-1.1,5.1v.6c0,2.4.4,4.1,1.1,5.2.7,1,1.8,1.6,3.3,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.8,371.8v5.7h4v4.5h-4v11.6c0,.9.2,1.5.5,1.8.3.4,1,.6,1.9.6s1.3,0,1.8-.2v4.7c-1.2.4-2.5.6-3.8.6-4.3,0-6.6-2.2-6.6-6.6v-12.5h-3.4v-4.5h3.4v-5.7h6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.5,400.7c-.3-.6-.5-1.2-.6-2.1-1.5,1.7-3.5,2.5-5.9,2.5s-4.2-.7-5.6-2-2.2-3-2.2-5,.9-4.3,2.7-5.7,4.5-2,7.9-2h2.9v-1.3c0-1.1-.3-1.9-.8-2.6-.6-.6-1.4-1-2.6-1s-1.9.2-2.5.8-.9,1.2-.9,2.1h-6.2c0-1.3.4-2.6,1.2-3.7.8-1.1,2-2,3.5-2.7,1.5-.6,3.2-1,5.1-1,2.9,0,5.1.7,6.8,2.2,1.7,1.4,2.5,3.5,2.5,6.1v10.1c0,2.2.3,3.9.9,5v.4h-6.3ZM210.4,396.4c.9,0,1.8-.2,2.5-.6.8-.4,1.3-1,1.7-1.6v-4h-2.3c-3.1,0-4.8,1.1-5,3.2v.4c0,.8.2,1.4.8,1.9s1.3.8,2.2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.4,389.7v11h-6.4v-31.2h12.2c2.3,0,4.4.4,6.2,1.3s3.1,2.1,4.1,3.7c1,1.6,1.4,3.4,1.4,5.4,0,3.1-1,5.5-3.1,7.2-2.1,1.8-5,2.6-8.7,2.6h-5.6ZM243.4,384.5h5.7c1.7,0,3-.4,3.9-1.2.9-.8,1.3-1.9,1.3-3.4s-.4-2.8-1.3-3.7-2.1-1.4-3.7-1.5h-5.9v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.9,383.3c-.8-.1-1.6-.2-2.2-.2-2.3,0-3.9.8-4.6,2.4v15.2h-6.2v-23.2h5.9l.2,2.8c1.2-2.1,3-3.2,5.2-3.2s1.3,0,1.9.3v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.1,388.9c0-2.3.4-4.4,1.3-6.2.9-1.8,2.2-3.2,3.8-4.2s3.6-1.5,5.8-1.5c3.1,0,5.7,1,7.7,2.9,2,1.9,3.1,4.5,3.3,7.8v1.6c0,3.6-.9,6.4-2.9,8.6s-4.7,3.2-8,3.2-6-1.1-8-3.2c-2-2.1-3-5.1-3-8.7v-.3ZM285.3,389.3c0,2.2.4,3.9,1.2,5.1s2,1.8,3.6,1.8,2.7-.6,3.5-1.7,1.3-3,1.3-5.5-.4-3.8-1.3-5-2-1.8-3.6-1.8-2.7.6-3.5,1.8c-.8,1.2-1.2,3-1.2,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304,388.9c0-3.6.8-6.5,2.4-8.6,1.6-2.1,3.8-3.2,6.7-3.2s4.1.8,5.6,2.5v-11.8h6.2v32.9h-5.6l-.3-2.5c-1.5,1.9-3.5,2.9-6,2.9s-4.9-1.1-6.6-3.2-2.5-5.1-2.5-9ZM310.2,389.4c0,2.2.4,3.8,1.1,5s1.9,1.7,3.3,1.7,3.3-.8,4.1-2.4v-9.2c-.8-1.6-2.1-2.4-4-2.4-3,0-4.5,2.4-4.5,7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.5,398.3c-1.5,1.9-3.6,2.8-6.3,2.8s-4.4-.7-5.7-2.1c-1.3-1.4-2-3.5-2-6.3v-15.2h6.2v15c0,2.4,1.1,3.6,3.3,3.6s3.5-.7,4.3-2.2v-16.4h6.2v23.2h-5.8l-.2-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.9,396.1c1.1,0,2.1-.3,2.8-.9s1.1-1.5,1.1-2.5h5.8c0,1.6-.4,3-1.3,4.3-.8,1.3-2,2.3-3.5,3-1.5.7-3.1,1.1-4.9,1.1-3.3,0-5.9-1.1-7.8-3.2-1.9-2.1-2.9-5-2.9-8.7v-.4c0-3.6.9-6.4,2.8-8.6s4.5-3.2,7.8-3.2,5.2.8,7,2.5,2.6,3.8,2.7,6.6h-5.8c0-1.2-.4-2.2-1.1-2.9s-1.7-1.1-2.8-1.1-2.5.5-3.3,1.6c-.7,1.1-1.1,2.8-1.1,5.1v.6c0,2.4.4,4.1,1.1,5.2.7,1,1.8,1.6,3.3,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.5,371.8v5.7h4v4.5h-4v11.6c0,.9.2,1.5.5,1.8.3.4,1,.6,1.9.6s1.3,0,1.8-.2v4.7c-1.2.4-2.5.6-3.8.6-4.3,0-6.6-2.2-6.6-6.6v-12.5h-3.4v-4.5h3.4v-5.7h6.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "wood_flooring_x2F_parquet_x2F_floors"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 70,
    y: 42.5,
    width: 284.5,
    height: 284.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 92.9,
    y1: 125.1,
    x2: 152.6,
    y2: 65.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 92.9,
    y1: 212.3,
    x2: 239.8,
    y2: 65.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 92.9,
    y1: 304.1,
    x2: 331.6,
    y2: 65.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.7,
    y1: 304.1,
    x2: 331.6,
    y2: 157.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 271.9,
    y1: 304.1,
    x2: 331.6,
    y2: 244.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 288.5,
    y1: 200.2,
    x2: 332.1,
    y2: 243.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 180.1,
    y1: 216.9,
    x2: 226.6,
    y2: 261.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 202.5,
    y1: 102.7,
    x2: 248.4,
    y2: 148.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 92.9,
    y1: 125.1,
    x2: 136.5,
    y2: 168.7
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "381 348.5 165 348.5 381 132.5 381 348.5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.1,295.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.1,295.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.1,346.3c-1.3,0-2.6-.5-3.7-1.4l-19.2-17.2-10,15.1c-.9,1.3-2.5,2.1-4.2,2-1.7-.1-3.2-1.1-3.8-2.5l-34-74.2c-.7-1.5-.3-3.1,1-4.3s3.1-1.5,4.8-.9l82.7,30.5h0c1.6.6,2.7,1.9,2.8,3.4.1,1.5-.7,3-2.2,3.8l-14.9,7.9,18.8,16.8c2,1.8,2,4.8,0,6.6l-14.3,12.9c-1,.9-2.3,1.4-3.7,1.4ZM358.7,320.3c.8,0,1.6.3,2.2.8l21.2,19.1,12.7-11.4-20.8-18.7c-.7-.6-1-1.5-.9-2.4.1-.9.7-1.6,1.5-2.1l15.2-8.1-74.9-27.6,30.8,67.2,10.2-15.4c.5-.8,1.4-1.3,2.3-1.4.1,0,.3,0,.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.6,259.6c-1.1,1-2.8,1-3.8,0l-18.4-16.5c-1.1-1-1.1-2.5,0-3.4s2.8-1,3.8,0l18.4,16.5c1.1,1,1.1,2.5,0,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.6,254.8c-.5.4-1.2.7-1.9.7-1.5,0-2.7-1.1-2.7-2.4v-23.3c0-1.3,1.2-2.4,2.7-2.4s2.7,1.1,2.7,2.4v23.3c0,.7-.3,1.3-.8,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.7,245.9l-18.4,16.5c-1.1,1-2.8,1-3.8,0s-1.1-2.5,0-3.4l18.4-16.5c1.1-1,2.8-1,3.8,0,1.1,1,1.1,2.5,0,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.4,281.9c-.5.4-1.2.7-1.9.7h-26c-1.5,0-2.7-1.1-2.7-2.4s1.2-2.4,2.7-2.4h26c1.5,0,2.7,1.1,2.7,2.4,0,.7-.3,1.3-.8,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.8,302.3l-18.4,16.5c-1.1,1-2.8,1-3.8,0s-1.1-2.5,0-3.4l18.4-16.5c1.1-1,2.8-1,3.8,0,1.1,1,1.1,2.5,0,3.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.223461642eb5043686cd3f0f775ff0c8.svg";
export { ForwardRef as ReactComponent };